import React from 'react';
import { withRouter} from 'react-router-dom';
import {
  Grid,
  Item,
  Form,
  Icon,
  Label,
  Segment,
  Input
} from 'semantic-ui-react';
import SandboxedHTMLContent from './SandboxedHTMLContent'
import mapConnection from '../utils/connectionMapper'

class EmailInput extends React.Component {
  state = { }

  handlePreviousEmailToggle(){
    this.setState({isPrevEmailVisible: !this.state.isPrevEmailVisible})
  }

  render = () => {
    const path = this.props.history.location.pathname;
    return (
      <Grid>
        {(path.indexOf("re") !== -1 || path.indexOf("contact") !== -1) ?
          <Grid.Row columns={2}>
            <Grid.Column width={7}>
              <Item.Meta>To</Item.Meta>
              { this.renderRecipient() }
            </Grid.Column>
            <Grid.Column width={7}>
              <Item.Meta>From</Item.Meta>
              <Label color='teal' image>
                  {this.props.senderEmail ? this.props.senderEmail : "myclaim@airrefund.com"}
              </Label>
            </Grid.Column>
          </Grid.Row>
          :
          <Grid.Row>
            <Grid.Column width={10}>
              <Item.Meta>To</Item.Meta>
              { this.renderRecipient() }
            </Grid.Column>
          </Grid.Row>
        }
        <Grid.Row>
          <Grid.Column width={10}>
            <Item.Meta>Subject</Item.Meta>
            <Item.Description>{this.props.subject}</Item.Description>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row >
          <Grid.Column>
            <Form>
              <Form.TextArea
                rows={25}
                onChange={this.props.onChange}
                value={this.props.body}
              />
            </Form>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="right">
          { this.props.previousEmail &&
            this.renderPrevEmail()
          }
          { this.props.previousEmail &&
            this.renderPrevEmailToggle()
          }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
  handleRecipientChange(_e, dropdown){
    this.props.onRecipientChange(dropdown.value)
  }
  renderRecipient() {
    if(this.props.recipientEditable){
      return (
        <Label color='teal' image>
          <Icon name={this.props.recipientIconName} />
          <Input value ={this.props.recipient} onChange={this.handleRecipientChange.bind(this)} />

        </Label>
      )
    } else {
      return (
        <Label color='teal' image>
            <Icon name={this.props.recipientIconName} />
            {this.props.recipient}
        </Label>
      )
    }
  }
  renderPrevEmail = () => {
    if(!this.state.isPrevEmailVisible){
      return null
    }

    const emailMessage = this.props.previousEmail

    if(emailMessage.htmlPart){
      return (
        <SandboxedHTMLContent
          contentStyle={{
            width: `100%`,
            height: `500px`,
            border: `none`
          }}
          documents={mapConnection(emailMessage.documentsConnection)}
          htmlPart={emailMessage.htmlPart}
        />
      )
    }
    return (
      <Segment textAlign="left" className="u-display-linebreak">
        {emailMessage.content}
      </Segment>
    )
  }
  renderPrevEmailToggle = () => {
    if(!this.state.isPrevEmailVisible)
      return (
        <a style={{color: "rgba(0,0,0,0.4)"}} onClick={this.handlePreviousEmailToggle.bind(this)}>
          Show previous e-mail
          <Icon name="chevron down"/>
        </a>
      )
    else
      return (
        <a style={{color: "rgba(0,0,0,0.4)"}} onClick={this.handlePreviousEmailToggle.bind(this)}>
          Hide previous e-mail
          <Icon name="chevron up"/>
        </a>
      )
  }

}

export default withRouter(EmailInput);



// WEBPACK FOOTER //
// ./src/component/EmailInput.js